/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automation_Runs_Load_MoreInputs */

const en_automation_runs_load_more = /** @type {(inputs: Automation_Runs_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Load more`)
};

const pt_br2_automation_runs_load_more = /** @type {(inputs: Automation_Runs_Load_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carregar mais`)
};

/**
* | output |
* | --- |
* | "Load more" |
*
* @param {Automation_Runs_Load_MoreInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automation_runs_load_more = /** @type {((inputs?: Automation_Runs_Load_MoreInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automation_Runs_Load_MoreInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automation_runs_load_more(inputs)
	return pt_br2_automation_runs_load_more(inputs)
});